import { TopBarThemedThemeModeConfig } from './types';

const light: TopBarThemedThemeModeConfig = {
  topBarThemed: {
    headingColor: 'white',
    headingBGColor: '#5B9AE1', // Example light background color
  },
};

export default light;